import { assetUrl } from "@/lib/api";

const EDGE = "radial-gradient(ellipse 72% 68% at 50% 50%, transparent 62%, rgba(0,0,0,.6) 80%, #000 92%)";
const EDGE_MASK = { WebkitMaskImage: EDGE, maskImage: EDGE };

export const SectionHead = ({ eyebrow, title, intro, light = false, className = "" }) => (
  <div className={`max-w-3xl ${className}`}>
    {eyebrow && <p className={`${light ? "eyebrow" : "eyebrow-dark"} mb-4`}>{eyebrow}</p>}
    <h2 className={`h-section ${light ? "text-ink" : "text-shell"}`}>{title}</h2>
    {intro && <p className={`mt-5 text-base sm:text-lg leading-relaxed font-light whitespace-pre-line ${light ? "text-mas-mute" : "text-shell/75"}`}>{intro}</p>}
  </div>
);

export const DoodlePhoto = ({ src, alt = "", className = "", doodles = true }) => (
  <div className={`relative overflow-hidden bg-ink ${className}`}>
    <img src={assetUrl(src)} alt={alt} className="w-full h-full object-cover" loading="lazy" />
    {doodles && <img src="/images/doodle-overlay.png" alt="" aria-hidden className="doodle-pop absolute inset-0 w-full h-full object-cover pointer-events-none" style={EDGE_MASK} />}
  </div>
);

export const DoodleBand = ({ className = "" }) => (
  <div aria-hidden className={`h-28 sm:h-40 bg-ink bg-center bg-cover ${className}`} style={{ backgroundImage: "url(/images/doodle-band.png)" }} data-testid="doodle-band" />
);

export const PageHero = ({ eyebrow, title, intro, image, children, testid }) => (
  <section className="relative" data-testid={testid}>
    {image && <DoodlePhoto src={image} className="h-[300px] sm:h-[420px] lg:h-[480px]" />}
    <div className="container-mas py-12 sm:py-16 grid lg:grid-cols-12 gap-8 items-end">
      <div className="lg:col-span-7 rise">
        <p className="eyebrow-dark mb-4">{eyebrow}</p>
        <h1 className="font-sans font-semibold tracking-tight text-4xl sm:text-5xl lg:text-6xl leading-[1]">{title}</h1>
      </div>
      <div className="lg:col-span-5 rise" style={{ animationDelay: ".1s" }}>
        {intro && <p className="text-base sm:text-lg text-shell/75 font-light leading-relaxed whitespace-pre-line">{intro}</p>}
        {children && <div className="mt-6 flex flex-wrap gap-3">{children}</div>}
      </div>
    </div>
  </section>
);

export const LightSection = ({ children, className = "", id, testid }) => (
  <section id={id} className={`bg-shell text-ink ${className}`} data-testid={testid}>{children}</section>
);
